import script from "./ProductModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductModal.vue?vue&type=script&lang=ts&setup=true"

import "./ProductModal.vue?vue&type=style&index=0&id=2edf9781&lang=scss"

const __exports__ = script;

export default __exports__